var $def  = require('./$.def')
  , $task = require('./$.task');
$def($def.G + $def.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/web.immediate.js
 ** module id = 340
 ** module chunks = 0
 **/